import { ConfigurationsState, Positions } from '../types/remoteConfig';

export const defaultConfig: ConfigurationsState = {
    shipping: {
        minOrderValue: null,
    },
    magalog: {
        toggle: false,
        url: '',
    },
    shopToClub: {
        isEnabled: false,
        mobileImage: '',
        mobileDelayInSeconds: 0,
        expirationInDays: 0,
        topBorderColor: '',
        isDismissable: true,
        clubPromoBannerImage: '',
        clubPromoBannerDesktopImage: '',
        isClubBannerDismissable: false,
        promoExpirationTime: 0,
        isUndismissableFromOutsideClick: false,
        pageViewLimit: '',
    },
    clubHeaderHighlightTab: {
        toggle: false,
        url: '',
    },
    moodboard: {
        enableMobileEntry: false,
    },
    specialSales: {
        strikeThroughColor: '',
        blackFridayBadgeColor: '',
        cyberMondayBadgeColor: '',
    },
    braze: {
        authentication: '',
        authenticationMobile: '',
        identifier: '',
    },
    isFetching: false,
    didInvalidate: false,
    identifier: '',
    isImageServiceProductImageEnabled: false,
    quantityBadgePosition: Positions.bottomleft,
    isVimeoVideoPlayerEnabled: false,
    isNativeVideoPlayerEnabled: false,
    isPdpClientSideNavigationEnabled: false,
    isPdpTaxDisclaimerEnabled: false,
};
